import { environment } from '../../config/environment';
import { storage } from '../../utils/storage';

export class BaseApiService {
  protected baseUrl: string;
  protected authUrl: string;

  constructor() {
    this.baseUrl = environment.API_URL;
    this.authUrl = environment.AUTH_API_URL;
  }

  protected async fetchWithAuth(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<any> {
    return this._fetch(endpoint, options, true);
  }

  protected async fetchPublic(
    endpoint: string,
    options: RequestInit = {}
  ): Promise<any> {
    return this._fetch(endpoint, options, false);
  }

  private async _fetch(
    endpoint: string,
    options: RequestInit = {},
    includeAuth: boolean
  ): Promise<any> {
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
      ...((options.headers as Record<string, string>) || {}),
    };

    if (includeAuth) {
      const token = storage.getAccessToken();
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
    }

    const response = await fetch(`${this.baseUrl}${endpoint}`, {
      ...options,
      headers,
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      const error = new Error(errorData.message || 'Request failed');
      (error as any).response = { status: response.status, data: errorData };
      throw error;
    }

    if (response.status === 204) {
      return { success: true };
    }

    return response.json();
  }
}
